import Analytics from '@components/charts/analytics/Analytics'
import { venueRangePresets } from '@components/charts/analytics/rangePresets'
import SpendPerDay from '@components/charts/venue/SpendPerDay'
import SpendPerPartySize from '@components/charts/venue/SpendPerPartySize'
import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import { ProductType } from '@models/Product'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Permission } from '@utils/permissions'
import { Col, Flex, Row, Space } from 'antd'
import { Dayjs } from 'dayjs'

const RevenuePage = () => {
  return (
    <AnalyticsProvider>
      <Page permissions={Permission.createAdmin} noWrapWithCol>
        <Col span={24}>
          <Flex vertical gap={16}>
            <PageTitle
              level={4}
              style={{ margin: 0 }}
              title={'Revenue & spends'}
              toolbar={
                <Space>
                  <Analytics.Product
                    showOnlyTypes={[
                      ProductType.All,
                      ProductType.App,
                      ProductType.Chatbot,
                      ProductType.Other,
                    ]}
                  />
                  <Analytics.Date
                    rangePresets={venueRangePresets}
                    defaultValue={venueRangePresets[0].value as [Dayjs, Dayjs]}
                  />
                </Space>
              }
            />
            <Analytics.RowStatistics
              entity="venue"
              entityId={1}
              kind="venue-app-revenue"
            />
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <SpendPerDay />
              </Col>
              <Col span={14}>
                <SpendPerPartySize />
              </Col>
            </Row>
          </Flex>
        </Col>
      </Page>
    </AnalyticsProvider>
  )
}

export default RevenuePage
